import { render } from "./BGZG9.vue?vue&type=template&id=5d47f714&scoped=true"
import script from "./BGZG9.vue?vue&type=script&lang=js"
export * from "./BGZG9.vue?vue&type=script&lang=js"

import "./BGZG9.vue?vue&type=style&index=0&id=5d47f714&lang=css"
import "./BGZG9.vue?vue&type=style&index=1&id=5d47f714&scoped=true&lang=css"

import exportComponent from "D:\\wcb\\www\\wifigolf\\s_api\\public\\ClpgaApp121\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d47f714"]])

export default __exports__